import * as Types from "../actionTypes/timerTypes";

export const countDown = () => ({ type: Types.COUNT_DOWN });

export const setTimer = (payload) => ({ type: Types.SET_TIME, payload });

export const countUp = () => ({ type: Types.COUNT_UP });

export const devCountUp = (payload) => ({ type: Types.DEV_COUNT_UP, payload });

export const devCountDown = (payload) => ({
  type: Types.DEV_COUNT_DOWN,
  payload,
});

// export const startTimer = () => ({ type: Types.START_TIMER });

// export const stopTimer = () => ({ type: Types.STOP_TIMER });
